import React, { useState, useEffect } from 'react';
import LoadingSkeleton from '../LoadingSkeleton/LoadingSkeleton';
import './RouteTransitionLoader.css';

interface RouteTransitionLoaderProps {
  isLoading?: boolean;
  delay?: number; // Delay in ms before showing the loader
}

const RouteTransitionLoader: React.FC<RouteTransitionLoaderProps> = ({
  isLoading = true,
  delay = 200 // Default 200ms delay - only show loader if loading takes longer than this
}) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowLoader(false);
      return;
    }

    // Only show loader if loading takes longer than the delay
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [isLoading, delay]);

  if (!showLoader || !isLoading) return null;

  return <LoadingSkeleton type="page" />;
};

export default RouteTransitionLoader;
